export default __webpack_public_path__ + "static/media/shop_button_new.3e817d3c.png";